'use strict';

// We have readapt imports in our overrides to take the base files
var keyboardAccessibility = require('base/components/keyboardAccessibility');
var $sideMenu = $('.main-menu');
var $header = $('.site-header');
var $menuBtn = $('.navbar-toggler');
var $overlay = $('.modal-background');
var $mobileUserPopover = $('.user .popover');
var $body = $('body');
var $back = $('.back-button');
var $SubMenuItem = $('.dropdown:not(.disabled) [data-toggle="dropdown"]');
var $lgbreakpoint = 1357;
var $mdBreakPoint = 760;

var clearSelection = function (element) {
    $(element).closest('.dropdown').children('.dropdown-menu').children('.top-category')
        .detach();
    $(element).closest('.dropdown.show').children('.nav-link').attr('aria-expanded', 'false');
    $(element).closest('.dropdown.show').children('.dropdown-menu').attr('aria-hidden', 'true');
    $(element).closest('.dropdown.show').removeClass('show');
    $('div.menu-group > ul.nav.navbar-nav > li.nav-item > a').attr('aria-hidden', 'false');
    $(element).closest('li').detach();
};

function updateMenuPosition() {
    var headerHeight = $header.outerHeight();
    $sideMenu.css({
        top: headerHeight + 'px',
        height: 'calc(100% - ' + headerHeight + 'px)'
    });
}

$(window).on('resize', function () {
    if ($(window).width() >= $lgbreakpoint && $('.main-menu').hasClass('in')) {
        $overlay.hide();
        $sideMenu.removeClass('in');
        $sideMenu.attr('aria-hidden', 'true');
        $sideMenu.siblings().attr('aria-hidden', 'false');
        $header.siblings().attr('aria-hidden', 'false');
        $menuBtn.removeClass('menu-open');
        if ($body.hasClass('noOverflow')) {
            $body.removeClass('noOverflow');
        }
    }

    if ($(window).width() < $lgbreakpoint && $sideMenu.hasClass('in')) {
        updateMenuPosition();
    }

    if ($(window).width() > $mdBreakPoint) {
        $mobileUserPopover.removeAttr('style');
    }

    if ($(window).width() > $lgbreakpoint) {
        $sideMenu.attr('style', '');
    }
}).trigger('resize');

module.exports = function () {
    var isDesktop = function () {
        return $(window).width() >= $lgbreakpoint; // $(element).parents('.menu-toggleable-left').css('position') !== 'fixed';
    };

    var headerBannerStatus = window.sessionStorage.getItem('hide_header_banner');
    $('.header-banner .close').on('click', function () {
        $('.header-banner').addClass('d-none');
    });

    if (!headerBannerStatus || headerBannerStatus < 0) {
        $('.header-banner').removeClass('d-none');
    }

    keyboardAccessibility('.main-menu .nav-link, .main-menu .dropdown-link', {
        40: function (menuItem) { // down
            if (menuItem.hasClass('nav-item')) { // top level
                $('.navbar-nav .show').removeClass('show')
                    .children('.dropdown-menu')
                    .removeClass('show');
                menuItem.addClass('show').children('.dropdown-menu').addClass('show');
                menuItem.find('ul > li > a')
                    .first()
                    .focus();
            } else {
                menuItem.removeClass('show').children('.dropdown-menu').removeClass('show');
                if (!(menuItem.next().length > 0)) { // if this is the last menuItem
                    menuItem.parent().parent().find('li > a') // set focus to the first menuitem
                        .first()
                        .focus();
                } else {
                    menuItem.next().children().first().focus();
                }
            }
        },
        39: function (menuItem) { // right
            if (menuItem.hasClass('nav-item')) { // top level
                menuItem.removeClass('show').children('.dropdown-menu').removeClass('show');
                $(this).attr('aria-expanded', 'false');
                menuItem.next().children().first().focus();
            } else if (menuItem.hasClass('dropdown')) {
                menuItem.addClass('show').children('.dropdown-menu').addClass('show');
                $(this).attr('aria-expanded', 'true');
                menuItem.find('ul > li > a')
                    .first()
                    .focus();
            }
        },
        38: function (menuItem) { // up
            if (menuItem.hasClass('nav-item')) { // top level
                menuItem.removeClass('show').children('.dropdown-menu').removeClass('show');
            } else if (menuItem.prev().length === 0) { // first menuItem
                menuItem.parent().parent().removeClass('show')
                    .children('.nav-link')
                    .attr('aria-expanded', 'false');
                menuItem.parent().children().last().children() // set the focus to the last menuItem
                    .first()
                    .focus();
            } else {
                menuItem.prev().children().first().focus();
            }
        },
        37: function (menuItem) { // left
            if (menuItem.hasClass('nav-item')) { // top level
                menuItem.removeClass('show').children('.dropdown-menu').removeClass('show');
                $(this).attr('aria-expanded', 'false');
                menuItem.prev().children().first().focus();
            } else {
                menuItem.closest('.show').removeClass('show')
                    .closest('li.show').removeClass('show')
                    .children()
                    .first()
                    .focus()
                    .attr('aria-expanded', 'false');
            }
        },
        27: function (menuItem) { // escape
            var parentMenu = menuItem.hasClass('show') ?
                menuItem :
                menuItem.closest('li.show');
            parentMenu.children('.show').removeClass('show');
            parentMenu.removeClass('show').children('.nav-link')
                .attr('aria-expanded', 'false');
            parentMenu.children().first().focus();
        }
    },
    function () {
        return $(this).parent();
    });

    $back.on('click', function () {
        if (!isDesktop()) {
            var dropdown = $SubMenuItem;
            if (dropdown.siblings('.menu-items-container').hasClass('show')) {
                dropdown.siblings('.menu-items-container').removeClass('show');
            }
        }
    });

    $SubMenuItem.on('click', function (e) {
        if (!isDesktop()) {
            if ($(this).parent('.dropdown').hasClass('has-subcategories')) {
                $(this).parent().toggleClass('open');
                $('#' + this.id + '-container').toggleClass('open').toggle();
            }
            $(this).siblings('.menu-items-container').toggleClass('show');
            if ($(this).attr('role') === 'button') {
                e.preventDefault();
            }
        }
    }).on('mouseenter', function () {
        if (isDesktop(this)) {
            var eventElement = this;
            $('.navbar-nav > li').each(function () {
                if (!$.contains(this, eventElement)) {
                    $(this).find('.show').each(function () {
                        clearSelection(this);
                    });
                    if ($(this).hasClass('show')) {
                        $(this).removeClass('show');
                        $(this).children('.menu-items-container').removeClass('show');
                        $(this).children('.nav-link').attr('aria-expanded', 'false');
                    }
                }
            });
            // need to close all the dropdowns that are not direct parent of current dropdown
            $(this).parent().addClass('show');

            var menuItem = $(this).siblings('.menu-items-container');

            menuItem.addClass('show');
            $(this).attr('aria-expanded', 'true');
        }
    }).parent().on('mouseleave', function () {
        if (isDesktop()) {
            $(this).removeClass('show');
            $(this).children('.menu-items-container').removeClass('show');
            $(this).children('.nav-link').attr('aria-expanded', 'false');
        }
    });

    $('.navbar-nav').on('click', '.back', function (e) {
        e.preventDefault();
        clearSelection(this);
    });

    $menuBtn.click(function (e) {
        e.preventDefault();
        $(this).toggleClass('menu-open');
        if ($(this).hasClass('menu-open')) {
            updateMenuPosition();
        }
        $body.toggleClass('noOverflow');
        $header.toggleClass('menu-open');
        $sideMenu.toggleClass('in');
        $overlay.toggle();
        $('.account-mobile').addClass('d-none');
        $('.search-mobile ').removeClass('d-none');
        $sideMenu.attr('aria-hidden', 'false');
        $sideMenu.siblings().attr('aria-hidden', 'true');
        $header.siblings().attr('aria-hidden', 'true');
    });

    $overlay.click(function (e) {
        e.preventDefault();
        $menuBtn.removeClass('menu-open');
        if ($menuBtn.hasClass('menu-open')) {
            updateMenuPosition();
        }
        if ($body.hasClass('noOverflow')) {
            $body.removeClass('noOverflow');
        }
        $header.removeClass('menu-open');
        $sideMenu.removeClass('in');
        $overlay.toggle();
        $('.account-mobile').addClass('d-none');
        $('.search-mobile ').removeClass('d-none');
        $sideMenu.attr('aria-hidden', 'false');
        $sideMenu.siblings().attr('aria-hidden', 'true');
        $header.siblings().attr('aria-hidden', 'true');
    });

    $(window).on('scroll', function () {
        if ($(window).scrollTop() > 50) {
            $header.addClass('fixed');
        } else {
            $header.removeClass('fixed');
        }
    });

    keyboardAccessibility('.navbar-header .user', {
        40: function ($popover) { // down
            if ($popover.children('a').first().is(':focus')) {
                $popover.next().children().first().focus();
            } else {
                $popover.children('a').first().focus();
            }
        },
        38: function ($popover) { // up
            if ($popover.children('a').first().is(':focus')) {
                $(this).focus();
                $popover.removeClass('show');
            } else {
                $popover.children('a').first().focus();
            }
        },
        27: function () { // escape
            $('.navbar-header .user .popover').removeClass('show');
            $('.user').attr('aria-expanded', 'false');
        },
        9: function () { // tab
            $('.navbar-header .user .popover').removeClass('show');
            $('.user').attr('aria-expanded', 'false');
        }
    },
    function () {
        var $popover = $('.user .popover li.nav-item');
        return $popover;
    });

    $('.navbar-header .user').on('mouseenter focusin', function () {
        if ($('.navbar-header .user .popover').length > 0) {
            $('.navbar-header .user .popover').addClass('show');
            $('.user').attr('aria-expanded', 'true');
        }
    });

    $('.navbar-header .user').on('mouseleave', function () {
        $('.navbar-header .user .popover').removeClass('show');
        $('.user').attr('aria-expanded', 'false');
    });

    $('body').on('click', '#myaccount', function (e) {
        e.preventDefault();
    });

    $('.login-userPanel_Btn').on('click', function () {
        sessionStorage.setItem('previousPage', window.location.href);
    });
};
